// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/pad-widget/pad-widget.less
// module id = 3363
// module chunks = 0